import React from 'react';
import { useAppVersionCheck } from '../hooks/useAppVersionCheck';

const NewVersionBanner: React.FC = () => {
  const { updateAvailable, reload } = useAppVersionCheck();
  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        flexWrap: 'wrap',
        padding: '10px 16px',
        backgroundColor: '#EEC930',
        color: '#1a1a1a',
        fontSize: 15,
        fontWeight: 600,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
      }}
    >
      <span>New version available, reload</span>
      <button
        type="button"
        onClick={reload}
        style={{
          backgroundColor: '#000000',
          color: '#EEC930',
          border: 'none',
          borderRadius: 4,
          padding: '6px 14px',
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
};

export default NewVersionBanner;
